import styled from '@emotion/styled';

export const MobileWrapper = styled.section<{ columns: number }>`
  display: grid;
  width: calc(100% - 32px);
  grid-template-columns: ${({ columns }) =>
    `repeat(${columns}, 1fr)`}; // 모바일에서 2개의 카드
  column-gap: 10px;
  row-gap: 30px;
  margin: 0 auto;
  padding: 0 0 80px;

  @media (min-width: 1040px) {
    display: none;
  }
`;

export const DesktopWrapper = styled.section<{ columns: number }>`
  display: none;

  @media (min-width: 1040px) {
    width: 100%;
    max-width: 820px;
    display: grid;
    grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
    column-gap: 20px;
    row-gap: 40px;
    margin: 0 auto;
    padding: 0 0 100px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  aspect-ratio: 1.5/1;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 14px;
  cursor: pointer;

  width: 100%;
  mask-image: -webkit-radial-gradient(circle, white, black);
`;
